import React from 'react';
import type { FC, ReactNode } from 'react';
import { Children } from 'react';

export enum FloatingPanelType {
    LIGHT = 'light',
    DARK = 'dark',
}

interface FloatingPanelProps {
    children: ReactNode[];
    className?: string;
    omitSeperator?: boolean;
    type?: FloatingPanelType;
    width?: number;
}

export const FloatingPanel: FC<FloatingPanelProps> = ({ children, className, omitSeperator, type, width }) => {
    return (
        <div className={className} style={{ width: width || undefined }}>
            <div
                className={`flex flex-col h-full w-full gap-2 ${type === FloatingPanelType.LIGHT ? 'bg-gray-150' : 'bg-black-50'} py-4 rounded-md`}
            >
                {Children.map(children, (child, index) => {
                    const lastChild = index === children.length - 1;
                    return (
                        <>
                            {child}
                            {!lastChild && !omitSeperator && <hr className="mt-2 bg-gray-100 border-gray-100" />}
                        </>
                    );
                })}
            </div>
        </div>
    );
};

interface FloatingPanelItemProps {
    children: ReactNode;
    className?: string;
}

export const FloatingPanelItem: FC<FloatingPanelItemProps> = ({ children, className }) => {
    return <div className={`${className}`}>{children}</div>;
};
